/* eslint-disable camelcase */

import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

import { WtpReviewService } from '../../services/wtp-review.service';
import { MneService } from '../../services/mne.service';
import { Country } from '../../models/country';
import { WtpReviewType } from '../../models/wtp-review-type';
import { WtpReviewTypeService } from '../../services/wtp-review-type.service';
import { WtpReview } from '../../models/wtp-review';

@Component({
  selector: 'app-wtp-review-edit',
  templateUrl: './wtp-review-edit.component.html',
})
export class WtpReviewEditComponent implements OnInit {

  wtp_review_id: number;
  wtpReview: WtpReview;
  wtp_review_type_id: number;
  value: string;
  country_id: number;
  error: any;

  countries: Country[] = [];
  wtpReviewTypes: WtpReviewType[] = [];

  subscriptions: Subscription[] = [];

  constructor(
    private _wtpReviewService: WtpReviewService,
    private _wtpReviewTypeService: WtpReviewTypeService,
    private _mneService: MneService,
    protected route: ActivatedRoute,
    protected router: Router
  ) { }

  ngOnInit() {
    this.wtp_review_id = +this.route.snapshot.paramMap.get('wtpReviewId');
    this.getCountries();
  }

  save(): void {
    const editWtpReview = {
      wtp_review_type_id: this.wtp_review_type_id,
      value: this.value,
      country_id: this.country_id,
    };
    this.subscriptions.push(
      this._wtpReviewService.update(editWtpReview, this.wtp_review_id).subscribe(() => {
        this.router.navigate(['/wtp/reviews']);
      },
      ({ error }) => {
        // This is uh...fun?
        this.error = error.error;
      })
    );
  }

  private getCountries(): void {
    this.subscriptions.push(
      this._mneService.listEntityCountries().subscribe(({ data }) => {
        this.countries = data;
        this.getTypes();
      })
    );
  }

  private getTypes(): void {
    this.subscriptions.push(
      this._wtpReviewTypeService.list().subscribe(({ data }) => {
        this.wtpReviewTypes = data;
        this.getReview();
      })
    );
  }

  private getReview(): void {
    this.subscriptions.push(
      this._wtpReviewService.get(this.wtp_review_id).subscribe(({ data }) => {
        this.wtpReview = data;
        this.wtp_review_type_id = this.wtpReview.wtp_review_type_id;
        this.value = this.wtpReview.value;
        this.country_id = this.wtpReview.country_id;
      })
    );
  }

  goBack(): void {
    this.router.navigate(['/wtp/reviews']);
  }

}

